module.exports = __webpack_public_path__ + "static/media/Flac.8b7ece76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/Flac.svg
// module id = 1695
// module chunks = 17